import { render, staticRenderFns } from "./BindWechat.vue?vue&type=template&id=224d5030&scoped=true&"
import script from "./BindWechat.vue?vue&type=script&lang=js&"
export * from "./BindWechat.vue?vue&type=script&lang=js&"
import style0 from "./BindWechat.vue?vue&type=style&index=0&id=224d5030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d5030",
  null
  
)

component.options.__file = "BindWechat.vue"
export default component.exports